import Insured from '@/modules/common/common/models/APP/Insured'
import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'
import { UserRoleEnum } from '@/modules/core/models/enums'
import ForeignHealthInsured from '@/modules/foreign-health/hiring/models/MID/ForeignHealthInsured'

export default class ForeignHealthRaterAnswers extends RaterAnswers {
  insuranceType: string
  initDate: Date
  endDate: Date | null
  stayAbroadType!: string

  constructor(data: any = {}) {
    super(data)

    this.forWhom = data.forWhom
    this.forWhomPeople = data.forWhomPeople ?? 1
    this.insuranceType = data.insuranceType
    this.initDate = data.initDate
    this.endDate = data.endDate
  }

  get holder(): Insured {
    if (super.holder) return super.holder
    const h = super.insureds.find((i) =>
      [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED].includes(i.role)
    )
    return h ? h : new ForeignHealthInsured({ role: UserRoleEnum.HOLDER_NOT_INSURED })
  }

  set holder(value: Insured | undefined) {
    super.holder = value
  }
}
